<template>
  <div class="house">
    <navBar></navBar>
    <div class="routerView">
      <router-view />
    </div>
    <!-- 联系悬浮 -->
    <div class="suspension">
      <!-- 
        :class="{
          suspension_mask_active: suspensionMessageVisible,
          suspension_mask_close: !suspensionMessageVisible,
        }" -->
      <div
        v-if="suspensionMessageVisible"
        class="suspension_mask"
        @click="suspensionMessageVisible = false"
      ></div>
      <!-- 展示按钮 -->
      <div
        v-if="$route.path != '/console/training'"
        class="suspension_button"
        @click="
          suspensionMessageVisible = suspensionMessageVisible ? false : true
        "
        :style="{
          bottom: clickTopShow ? '252px !important' : '',
        }"
      >
        <svg
          t="1732844837108"
          class="icon suspension_button_img"
          viewBox="0 0 1157 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="20030"
          width="27"
        >
          <path
            d="M774.188522 675.84c-52.847304 61.44-114.777043 90.423652-195.405913 90.423652-82.142609 0-137.572174-25.510957-195.361392-90.37913-12.288-14.246957-9.171478-36.062609 5.075479-48.172522 14.202435-12.109913 35.929043-9.037913 47.771826 4.763826 43.76487 47.949913 80.896 64.556522 142.514087 64.556522 59.392 0 101.821217-19.589565 142.246956-64.24487 12.109913-14.06887 33.836522-17.185391 48.083478-5.075478 14.202435 12.154435 17.318957 33.925565 5.075479 48.172522z m-334.180174-216.553739a49.41913 49.41913 0 0 1-98.838261 0V388.986435a49.41913 49.41913 0 0 1 98.838261 0v70.299826zM1157.565217 541.295304c0 85.704348-54.00487 158.72-127.688347 175.282087a511.554783 511.554783 0 0 1-180.090435 213.125566c0.445217 3.33913 0.75687 6.589217 0.756869 9.883826A84.769391 84.769391 0 0 1 765.862957 1024a84.769391 84.769391 0 0 1-84.72487-84.413217c0-46.525217 38.110609-84.457739 85.036522-84.45774 4.630261 0.089043 9.216 0.578783 13.801739 1.469218 120.965565-72.704 196.429913-204.265739 196.429913-350.475131 0-225.146435-178.265043-407.552-397.579131-407.552-219.40313 0-397.668174 182.405565-397.668173 407.596522a409.065739 409.065739 0 0 0 47.771826 192.467478l11.041391 20.791653H137.661217a12.822261 12.822261 0 0 1-7.791304-2.092522C55.073391 703.443478 0 628.869565 0 541.295304c0-74.529391 39.535304-140.421565 98.660174-166.244174C156.40487 155.826087 352.256 0 578.782609 0c226.526609 0 422.422261 155.826087 480.122434 375.140174C1117.45113 401.14087 1157.565217 467.389217 1157.565217 541.295304z m-341.170087-82.009043a49.41913 49.41913 0 0 1-98.793739 0V388.986435a49.41913 49.41913 0 0 1 98.838261 0v70.299826z"
            fill="#000000"
            p-id="20031"
          ></path>
        </svg>
        <span class="suspension_button_Text">立即咨询</span>
      </div>
      <!-- 信息弹框 -->
      <div
        class="suspension_message"
        :class="{ suspension_message_active: suspensionMessageVisible }"
        :style="{
          bottom: clickTopShow ? '252px !important' : '',
        }"
      >
        <CloseOutlined
          class="suspension_close"
          @click="suspensionMessageVisible = false"
        />
        <div class="suspension_cut">
          <div
            class="suspension_cut_item"
            :class="{ suspension_cut_item_active: suspensionMessageType == 1 }"
            @click="suspensionMessageType = 1"
          >
            联系客服
          </div>
          <div
            class="suspension_cut_item"
            :class="{ suspension_cut_item_active: suspensionMessageType == 2 }"
            @click="suspensionMessageType = 2"
          >
            商务合作
          </div>
          <div
            class="suspension_cut_item"
            :class="{ suspension_cut_item_active: suspensionMessageType == 3 }"
            @click="suspensionMessageType = 3"
          >
            创作者服务
          </div>
        </div>
        <div class="suspension_content">
          <div class="suspension_QRCode" v-if="suspensionMessageType == 1">
            <img
              class="suspension_img"
              :src="`https://img.cyuai.com/cpn/material/2d94989e80984f97a76126639603cbad.png?${dayjs().format(
                'YYYYMMDDHH'
              )}`"
              alt="img"
            />
            <div class="suspension_Phone">&nbsp;</div>
          </div>
          <div class="suspension_QRCode" v-if="suspensionMessageType == 2">
            <img
              class="suspension_img"
              :src="`https://img.cyuai.com/cpn/material/528d8adfce5e4dc6b4765802dcd71f1d.png?${dayjs().format(
                'YYYYMMDDHH'
              )}`"
              alt="img"
            />
            <div class="suspension_Phone">电话：132 0571 2110</div>
          </div>
          <div class="suspension_QRCode" v-if="suspensionMessageType == 3">
            <img
              class="suspension_img"
              :src="`https://img.cyuai.com/cpn/material/75fa88df078f43489e70002cec77b564.png?${dayjs().format(
                'YYYYMMDDHH'
              )}`"
              alt="img"
            />
            <div class="suspension_Phone">电话：195 2153 5956</div>
          </div>
          <div class="suspension_miaoshu" v-if="suspensionMessageType == 1">
            <div class="suspension_miaoshu_item">
              晨羽智云(杭州)科技有限公司
            </div>
            <div class="suspension_miaoshu_item">
              地址：浙江省杭州市西湖区教工路88号1006
            </div>
            <span
              v-if="user?.insider == 1"
              style="
                color: #666666;
                position: absolute;
                left: 25px;
                bottom: 10px;
                font-size: 12px;
              "
            >
              版本：V{{ version }}
            </span>
          </div>
          <div class="suspension_miaoshu" v-if="suspensionMessageType == 2">
            <div
              class="suspension_miaoshu_item"
              style="display: flex; align-items: center"
            >
              <svg
                t="1723443089641"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3307"
                width="10"
                height="10"
                style="margin-right: 3px"
              >
                <path
                  d="M887 430.2c3.4-3.5 1.4-9.4-3.4-10.1l-250.2-38.2c-2-0.3-3.7-1.6-4.5-3.4l-112.3-239c-2.2-4.6-8.7-4.6-10.9 0l-112.3 239c-0.9 1.8-2.5 3.1-4.5 3.4l-250.2 38.2c-4.8 0.7-6.8 6.6-3.4 10.1l181.4 185.7a6.2 6.2 0 0 1 1.6 5.2l-42.9 262.7c-0.8 4.9 4.4 8.6 8.8 6.2l224-123.7c1.8-1 4-1 5.8 0L738 890c4.4 2.4 9.6-1.3 8.8-6.2L704 621c-0.3-1.9 0.3-3.8 1.6-5.2L887 430.2z"
                  fill="rgba(102, 102, 102)"
                  p-id="3308"
                ></path>
              </svg>
              租赁训练请联系132 0571 2110
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 
<script>
import { CloseOutlined } from "@ant-design/icons-vue";
import navBar from "./house/components/navBar.vue";
import { version } from "../../version.json";
export default {
  name: "house",
  components: { navBar, CloseOutlined },
  data() {
    return {
      version: version,
      suspensionMessageVisible: false,
      suspensionMessageType: 1,
    };
  },
  mounted() {
    this.changeClickTopShowState(false);
  },
  computed: {},
  methods: {},
};
</script>
  
<style lang="scss" scoped>
// 1.移动端house不再限制高度
// 2.由于subject是高度100%，house又不再限制高度，所以也会自动撑开,但是overflow最好重置为初始值
// 这样内部容器就不会滚动，自动撑开
// html发现被撑开，会从最外层滚动
@media (max-width: 600px) {
  .house {
    height: auto !important;
    .routerView {
      overflow: visible !important;
    }
    // 悬浮
    .suspension {
      display: none;
    }
  }
}
.house {
  width: 100%;
  height: 100%;
  color: #000;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  .routerView {
    width: 100%;
    min-width: 300px;
    height: calc(100% - 52px);
    box-sizing: border-box;
    overflow: overlay;
  }
  // 联系悬浮
  .suspension {
    // 蒙版
    @keyframes rippleAni {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .suspension_mask {
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0px;
      left: 0px;
      background: #00000000;
      // background: rgba(0, 0, 0, 0.45);
      backdrop-filter: blur(2px); // 模糊
      z-index: 600;
      // animation: rippleAni 0.2s ease;
    }
    // 展开
    .suspension_mask_active {
      display: block;
    }
    // 关闭
    .suspension_mask_close {
      display: none;
    }
    // 展示按钮
    .suspension_button {
      width: 69px;
      height: 69px;
      background: linear-gradient(180deg, #feffff 0%, #f0f9ff 100%);
      box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;

      position: fixed;
      bottom: 252px;
      right: 32px;
      z-index: 602;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      padding: 5px 0;
      box-sizing: border-box;
      cursor: pointer;
      .suspension_button_img {
        pointer-events: none;
      }
      .suspension_button_Text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #000000;
        line-height: 16px;
        text-align: right;
        font-style: normal;
      }
    }
    // 信息弹框
    .suspension_message {
      transform: scale(0);
      width: 300px;
      height: 400px;
      max-width: calc(100% - 100px);
      max-height: calc(100% - 100px);
      background: white;
      color: #000;
      position: fixed;
      bottom: 252px;
      right: 30px;
      border-radius: 12px;
      box-shadow: 0 0 0.5rem rgba(177, 184, 194, 0.5);
      transform-origin: 100% 100%;
      transition: all 0.2s;
      z-index: 601;
      display: flex;
      flex-direction: column;
      .suspension_close {
        width: 40px;
        height: 40px;
        background: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -50px;
        right: 0px;
        cursor: pointer;
        box-shadow: 0 0 0.5rem rgba(177, 184, 194, 0.5);
      }
      .suspension_cut {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        overflow: hidden;
        height: 40px;
        display: flex;
        background: rgba(239, 239, 239, 0.6);
        .suspension_cut_item {
          width: 90px;
          padding: 0 5px;
          line-height: 40px;
          text-align: center;
          cursor: pointer;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .suspension_cut_item_active {
          width: 120px;
          background: white;
        }
      }
      .suspension_content {
        height: 100%;
        padding-bottom: 80px;
        box-sizing: border-box;
        overflow-y: overlay;
        .suspension_QRCode {
          text-align: center;
          .suspension_img {
            width: 120px;
            margin: 20px 0;
          }
          .suspension_Phone {
            color: rgba(102, 102, 102, 1);
            font-size: 15px;
            letter-spacing: 0.699999988079071px;
          }
        }
        .suspension_miaoshu {
          width: 100%;
          padding: 0 15px;
          box-sizing: border-box;
          text-align: start;
          margin: 20px 0 0;
          .suspension_miaoshu_item {
            color: rgba(102, 102, 102, 1);
            font-size: 15px;
            letter-spacing: 0.699999988079071px;
            line-height: 20px;
          }
        }
      }
    }
    .suspension_message_active {
      transform: scale(1);
    }
  }
}
</style>
  